var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('activation-brief-networks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var handleCompleteConnection = ref.handleCompleteConnection;
return [_c('activation-brief-connect-network-failed-view',{on:{"go-to-source":_vm.goToSource}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }